import React, {useEffect, useRef, useState} from "react"
import {connect, useDispatch, useSelector} from "react-redux"
import Styles from "./layer.less"
import UploadFileNav from "./wrapper/wrapper"
import TDACanvas from "./canvas/canvas"
import {ReducerState} from "../../../../../reducer/interface/baseInterface"
import {FileInfo} from "../../../../../reducer/interface/fileInterface"
import {CanvasDataByType, ImageItemData, OncePageCanvasData} from "../../../../../reducer/interface/dataInterface"
import {Dispatch} from "redux"
import {handlePageJump, scrollOnePx} from "../../../../../function/base/jumpToPage"

let scrollInterval: any = null

const contain = (scrollControl: {top: number; bottom: number}, position: {top: number; bottom: number}) => {
    const top = position.top
    const bottom = position.bottom
    if (scrollControl.top >= top && scrollControl.top <= bottom) {
        return true
    } else if (scrollControl.bottom >= top && scrollControl.bottom <= bottom) {
        return true
    } else if (scrollControl.top <= top && scrollControl.bottom >= bottom) {
        return true
    } else {
        return false
    }
}

const caluPosition = (
    pageItemPosition: any,
    dispatch: Dispatch,
    // scrollControl: {top: number; bottom: number},
    baseScrollControl: {top: number; bottom: number},
    compareScrollControl: {top: number; bottom: number}
) => {
    let clonePosition: any = {
        Base: pageItemPosition["Base"],
        Compare: pageItemPosition["Compare"],
    }
    clonePosition["Base"] = pageItemPosition["Base"].map((item: any) => {
        // return {...item, hasData: item.hasData ? item.hasData : contain(scrollControl, item.position)}
        return {...item, hasData: contain(baseScrollControl, item.position)}
    })
    clonePosition["Compare"] = pageItemPosition["Compare"].map((item: any) => {
        // return {...item, hasData: item.hasData ? item.hasData : contain(scrollControl, item.position)}
        return {...item, hasData: contain(compareScrollControl, item.position)}
    })
    dispatch({type: "saveAllPageItemPosition", payload: clonePosition})
}

interface LayerProps {
    type: string
    title: string
    fileInfo: FileInfo
    canvasData: Array<CanvasDataByType>
    imgList: Array<ImageItemData>
    scaleScal: number
    pageItemPosition: any
    pageJump: any
}

const Layer: React.FunctionComponent<LayerProps> = ({
    type,
    title,
    pageItemPosition,
    fileInfo,
    scaleScal,
    canvasData,
    imgList,
    pageJump,
}) => {
    const displayRef = useRef<HTMLDivElement>(null)
    const dispatch = useDispatch()
    useEffect(() => {
        if (scrollInterval !== null) {
            clearInterval(scrollInterval)
        }
        scrollInterval = null
        return () => {
            if (scrollInterval !== null) {
                clearInterval(scrollInterval)
            }
            scrollInterval = null
        }
    })
    useEffect(() => {
        scrollOnePx()
    }, [scaleScal])
    useEffect(() => {
        if (displayRef.current && pageJump[type].jump) {
            handlePageJump(displayRef.current, pageJump, type)
        }
    }, [pageJump])
    const afterScroll = () => {
        if (scrollInterval === null) {
            scrollInterval = setInterval(() => {
                if (topValue.current !== displayRef.current?.scrollTop) {
                    caluPosition(
                        pageItemPosition,
                        dispatch,
                        {
                            top: document.getElementById("BaseCanvasBox")?.scrollTop
                                ? document.getElementById("BaseCanvasBox")?.scrollTop!
                                : 0,
                            //  + displayRef.current.offsetHeight / 4,
                            bottom:
                                document.getElementById("BaseCanvasBox")?.scrollTop &&
                                document.getElementById("BaseCanvasBox")?.offsetHeight
                                    ? document.getElementById("BaseCanvasBox")?.scrollTop! +
                                      document.getElementById("BaseCanvasBox")?.offsetHeight!
                                    : 0,
                            // (displayRef.current.offsetHeight * 3) / 4,
                        },
                        {
                            top: document.getElementById("CompareCanvasBox")?.scrollTop
                                ? document.getElementById("CompareCanvasBox")?.scrollTop!
                                : 0,
                            //  + displayRef.current.offsetHeight / 4,
                            bottom:
                                document.getElementById("CompareCanvasBox")?.scrollTop &&
                                document.getElementById("CompareCanvasBox")?.offsetHeight
                                    ? document.getElementById("CompareCanvasBox")?.scrollTop! +
                                      document.getElementById("CompareCanvasBox")?.offsetHeight!
                                    : 0,
                            // (displayRef.current.offsetHeight * 3) / 4,
                        }
                        // {
                        //     top: displayRef.current?.scrollTop ? displayRef.current?.scrollTop : 0,
                        //     //  + displayRef.current.offsetHeight / 4,
                        //     bottom:
                        //         displayRef.current?.scrollTop && displayRef.current?.offsetHeight
                        //             ? displayRef.current?.scrollTop + displayRef.current?.offsetHeight
                        //             : 0,
                        //     // (displayRef.current.offsetHeight * 3) / 4,
                        // },
                    )
                    clearInterval(scrollInterval)
                    scrollInterval = null
                } else {
                    topValue.current = displayRef.current?.scrollTop
                }
            }, 500)
        }
    }
    const handleScroll = (x: number, y: number) => {
        displayRef.current?.scrollTo &&
            displayRef.current?.scrollTo(displayRef.current.scrollLeft - x, displayRef.current.scrollTop - y)
    }
    const topValue = useRef(0)
    return (
        <div key={`${type}CanvasBody`} className={Styles.documentBox}>
            <UploadFileNav type={type} title={title} fileInfo={fileInfo} />
            <div id={`${type}CanvasBox`} ref={displayRef} className={Styles.canvasBox} onScroll={() => afterScroll()}>
                <TDACanvas
                    canvasData={canvasData}
                    baseRef={displayRef}
                    imgList={imgList}
                    scrollMove={handleScroll}
                    type={type}
                />
            </div>
        </div>
    )
}
export default connect((state: ReducerState) => {
    return {
        pageItemPosition: state.control.pageItemPosition,
        comparisonStatus: state.control.comparisonStatus,
        scaleScal: state.data.scaleScal,
        pageJump: state.control.pageJump,
    }
})(Layer)
